<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/images/banner_12.png" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>纯化仪</h2>
          <p style="line-height: 2;font-size: 16px">用于培养基生产企业、制药企业、医院、公共健康、疾病预防控制中
            心、出入境检验检疫局、质量技术监督局、兽医、研究所、大学、化
            妆品、食品行业。</p>

            <p class="mt10" style="line-height: 2;font-size: 16px">广泛应用于DNA、RNA、LNA、硫代、修饰等引物的氨解前脱保护
            和氨解。</p>
        </div>
        <div class="img_a" style="width:40%"><img src="@/assets/images/akta_1.png" width="100%" class="product"></div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="7">
          <div class="tc"><img src="@/assets/images/akta_1.png" width="240"></div>
        </el-col>
        <el-col :span="17">
          <ul class="lists">
            <li>纯化仪主要用于对DNA合成引物进行自动化的脱保护及纯化；</li>
            <li>可对96、384合成板进行纯化，2个固定板位，功能强大，具有洗
              脱彻底、快速、方便，省时等优点；</li>
            <li>适合需要对大量DNA产物进行脱保护及纯化的企业和研发机构。</li>
          </ul>
        </el-col>
      </el-row>
    </section>
    <section class="save">
      <div class="c-title">存储环境条件</div>
      <div class="container container1">
        <ul>
          <li>
            <img src="@/assets/images/save_icon_1.png">
            <p>储存位置的环境温度必须
              在- 20 °C ~ + 65 °C（-4 °F
              ~ 149 °F）范围内</p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_4.png">
            <p>储存位置的相对湿度必须在
              0~90%范围内，且无结露 </p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_5.png">
            <p>避免储存于含有腐蚀性气、
              液体的环境中</p>
          </li>
        </ul>
      </div>
    </section>
    <section class="container container1">
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">电源</td>
              <td>220 ACV 50 Hz</td>
            </tr>
            <tr>
              <td>功率</td>
              <td>1 kW</td>
            </tr>
            <tr>
              <td>温度</td>
              <td>20 ± 5 ℃</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">湿度</td>
              <td>≤ 40% RH</td>
            </tr>
            <tr>
              <td>合成板</td>
              <td>2块96、384孔板</td>
            </tr>
            <tr>
              <td>外形尺寸</td>
              <td>1050 x 460 x 455 mm</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </section>
  </div>

</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<style scoped lang="scss">
.lists{
    display: unset !important;
    li{
      text-align: left;
    }
  }
  /deep/.right-col{
    padding: 0 !important;
  }
  .center-ele{
  margin-left: 100px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-35px;
}
.desc-eh{
  margin-top:-16px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/AKTA.vue